import Gen4Agenda from "./gen4Agenda";

export default Gen4Agenda;
